<template>
  <div
    class="container-fluid d-flex flex-wrap main-wrapper"
    style="height: 90vh; background: #FCF6F6"
  >
    <div class="col-12 p-0">
      <div class="border-0 d-flex flex-column text-white">
        <div class="d-flex justify-content-between">
          <h3 class="mb-0 text-white pl-2 pt-2" style="color: #FF4F4B !important;">
            {{ $t("transaction.transactions") }}
          </h3>
          <div class="tabs d-flex">
            <button
              type="button"
              class="btn btn-primary"
              v-for="tab in tabs"
              :key="tab.name"
              @click="selectedTab = tab.name"
              :class="{ active: selectedTab === tab.name }"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="table betslip-table pb-3 bg-transparent pt-3"
        style="height: 60vh; overflow-y: auto"
      >
        <div class="tab-content">
          <component :is="currentTabComponent" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserTransactions from "./components/UserTransactions.vue";
import UserDepositTable from "./components/UserDepositTable.vue";
import UserWithdrawTable from "./components/UserWithdrawTable.vue";

export default {
  components: {
    UserTransactions,
    UserDepositTable,
    UserWithdrawTable,
  },
  data() {
    return {
      selectedTab: "transactions",
      tabs: [
        {
          name: "transactions",
          label: "ကစားမှတ်တမ်း",
          component: "UserTransactions",
        },
        {
          name: "deposits",
          label: this.$t("transaction.deposit"),
          component: "UserDepositTable",
        },
        {
          name: "withdraws",
          label: this.$t("transaction.withdraw"),
          component: "UserWithdrawTable",
        },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find((t) => t.name === this.selectedTab);
      return tab ? tab.component : null;
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>

<style scoped>
.betslip-table {
  background: white;
}

.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}

.main-wrapper {
  padding: 7px !important;
}

.btn {
  height: 30px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-right: 1rem !important;
  padding-left: 1rem !important;
  margin-top: 3px !important;
  margin-bottom: 3px !important;
  box-shadow: none !important;
  background: #282a31 !important;
  white-space: nowrap;
}

.btn-primary.active {
  /* background: linear-gradient(
    to bottom,
    #ffc500 0%,
    #ff4500 50%,
    #c71600 100%
  ) !important;
  color: white !important; */
  background: #C7A241 !important;
  font-weight: 600;
  font-size: 1rem;
  color: black !important;
}
</style>
